import { Button } from "@mui/material";
import { FormattedMessage } from "react-intl";

interface ManageUsersButtonTemplateProps {
	readonly onClick: () => Promise<void>;
}

export const ManageUsersButtonTemplate = ({ onClick }: ManageUsersButtonTemplateProps) => (
	<Button variant="contained" onClick={onClick} data-testid="users__button__manage-users">
		<FormattedMessage id="Manage Users" defaultMessage="Manage Users" />
	</Button>
);
